import React from 'react';

/** The cover's overlapping-circles motif, in the pastel palette. */
const fills = ['#8FAAD6', '#7FB2AE', '#A8C29A', '#F0AF88', '#E5A8B3', '#9C8FC8', '#8FAAD6'];
export function SeedPaths({
  r = 28
}: {
  r?: number;
}) {
  const centers = [[0, 0]].concat(Array.from({
    length: 6
  }).map((_, k) => [r * Math.cos(k * Math.PI / 3), r * Math.sin(k * Math.PI / 3)]));
  return <g data-id="element-297" data-mp="2reqih8ecj3lo">
      {centers.map(([x, y], i) => <circle key={i} cx={x} cy={y} r={r} fill={fills[i]} fillOpacity={0.42} stroke="#FFFFFF" strokeWidth={1.4} style={{
      mixBlendMode: 'multiply'
    }} data-id="element-298" data-mp="2rdp3isu7lwyo" data-mpi={i} />)}
    </g>;
}
export function Seed({
  className = ''
}: {
  className?: string;
}) {
  return <svg aria-hidden="true" viewBox="-60 -60 120 120" className={className} data-id="element-299" data-mp="16yvlj54lrmqg">
      <SeedPaths data-id="element-300" data-mp="1bwx47oy49k1e" />
    </svg>;
}